import { useState, useCallback } from 'react';
import useToken from 'hooks/useToken';
import { useToast } from 'context/providers/ToastProvider';
/**
 * Hook para gestionar el tipo de cambio con BANXICO
 */
const useTipoCambio = (totales, setTotales) => {
    const { token, setToken } = useToken();
    const [consultandoTC, setConsultandoTC] = useState(false);
    const { showErrorToast } = useToast();
    /**
     * Obtiene el tipo de cambio de BANXICO
     */
    const obtenerBanxicoTC = useCallback(async (dateParam_ = '') => {
        console.log(dateParam_);
        console.log(totales.dFechaVenta);

        const date_ = (dateParam_ === '') 
            ? new Date(totales.dFechaVenta).toLocaleString('sv', { timeZoneName: 'short' }).substring(0, 10) 
            : new Date(dateParam_).toLocaleString('sv', { timeZoneName: 'short' }).substring(0, 10);

        const fechaVenta = (dateParam_ === '') ? totales.dFechaVenta : dateParam_;

        console.log(date_);
        setConsultandoTC(true);

        try {
            const response = await fetch(
                `https://www.banxico.org.mx/SieAPIRest/service/v1/series/SF60653/datos/${date_}/${date_}?decimales=sinCeros&token=7d0140dc6159dbe4a870c61dce8136190da8e9757776cb679483bdaaa31643e6`,
                { method: 'GET' }
            );

            if (response.ok) {
                const data = await response.json();
                console.log(data);
                console.log(data.bmx.series[0].datos[0].dato);

                setTotales(prev => ({ 
                    ...prev, 
                    vMoneda: "USD", 
                    dTipoCambio: parseFloat(data.bmx.series[0].datos[0].dato), 
                    dFechaVenta: new Date(fechaVenta) + "" 
                }));
            } else {
                
                showErrorToast(response.status + ' ' + response.statusText);
                
                if (response.status === 401) {
                    setToken(null);
                    location.href = "";
                }
                
                // Fallback
                alert("Hubo un problema con la conexión al Banco de México, por lo que estableceremos el Tipo de Cambio a 19.555.");
                setTotales(prev => ({ 
                    ...prev, 
                    vMoneda: "USD", 
                    dTipoCambio: 19.555, 
                    dFechaVenta: new Date(fechaVenta) + "" 
                }));
            }
        } catch (error) {
            
            showErrorToast('' + error.message);
            
            // Fallback
            alert("Hubo un problema con la conexión al Banco de México, por lo que estableceremos el Tipo de Cambio a 19.555.");
            setTotales(prev => ({ 
                ...prev, 
                vMoneda: "USD", 
                dTipoCambio: 19.555, 
                dFechaVenta: new Date(fechaVenta) + "" 
            }));
            
            console.log('Hubo un problema con la peticion Fetch:' + error.message);
        } finally {
            setConsultandoTC(false);
        }
    }, [totales.dFechaVenta, setTotales, token, setToken]);

    return {
        consultandoTC,
        obtenerBanxicoTC
    };
};

export default useTipoCambio;
